__turbopack_context__.v({
  "btnSearchSite": "MegaNav-module-scss-module__l5HbCq__btnSearchSite",
  "container": "MegaNav-module-scss-module__l5HbCq__container",
  "desktopDropDown": "MegaNav-module-scss-module__l5HbCq__desktopDropDown",
  "hamburgerSprite": "MegaNav-module-scss-module__l5HbCq__hamburgerSprite",
  "isMobileMenuOpen": "MegaNav-module-scss-module__l5HbCq__isMobileMenuOpen",
  "linkTitle": "MegaNav-module-scss-module__l5HbCq__linkTitle",
  "meganav": "MegaNav-module-scss-module__l5HbCq__meganav",
  "meganavDesktop": "MegaNav-module-scss-module__l5HbCq__meganavDesktop",
  "meganavMobile": "MegaNav-module-scss-module__l5HbCq__meganavMobile",
  "metaNav": "MegaNav-module-scss-module__l5HbCq__metaNav",
  "mobileHamburgerOpened": "MegaNav-module-scss-module__l5HbCq__mobileHamburgerOpened",
  "navThreatLabz": "MegaNav-module-scss-module__l5HbCq__navThreatLabz",
  "navigationDesktop": "MegaNav-module-scss-module__l5HbCq__navigationDesktop",
  "subnavBtn": "MegaNav-module-scss-module__l5HbCq__subnavBtn",
});
